import Vue from 'vue'

/**
 * @author: POPE
 * @description: 自定义指令-对话框拖拽
 * @param {type}
 * @return:
 */
Vue.directive('dialogDrag', {
  bind(el, binding, vnode, oldVnode) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header')
    const dragDom = el.querySelector('.el-dialog')
    dialogHeaderEl.style.cursor = 'move'

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)

    dialogHeaderEl.onmousedown = e => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop

      // 获取到的值带px 正则匹配替换
      let styL, styT

      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100) // eslint-disable-line
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100) // eslint-disable-line
      } else {
        styL = +sty.left.replace(/\px/g, '') // eslint-disable-line
        styT = +sty.top.replace(/\px/g, '') // eslint-disable-line
      }

      document.onmousemove = function(e) {
        // 通过事件委托，计算移动的距离
        const l = e.clientX - disX
        const t = e.clientY - disY

        // 移动当前元素
        dragDom.style.left = `${l + styL}px`
        dragDom.style.top = `${t + styT}px`

        // 将此时的位置传出去
        // binding.value({x:e.pageX,y:e.pageY})
      }

      document.onmouseup = function(e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
})

/**
 * @author: POPE
 * @description: 自定义指令-对话框拖拽
 * @param {type}
 * @return:
 */
 Vue.directive('cardDrag', {
  bind(el, binding, vnode, oldVnode) {
    const dialogHeaderEl = el.querySelector('.el-card__header')
    const dragDom = el
    dialogHeaderEl.style.cursor = 'move'

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)

    dialogHeaderEl.onmousedown = e => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop

      // 获取到的值带px 正则匹配替换
      let styL, styT

      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100) // eslint-disable-line
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100) // eslint-disable-line
      } else {
        styL = +sty.left.replace(/\px/g, '') // eslint-disable-line
        styT = +sty.top.replace(/\px/g, '') // eslint-disable-line
      }

      document.onmousemove = function(e) {
        // 通过事件委托，计算移动的距离
        const l = e.clientX - disX
        const t = e.clientY - disY

        // 移动当前元素
        dragDom.style.left = `${l + styL}px`
        dragDom.style.top = `${t + styT}px`

        // 将此时的位置传出去
        // binding.value({x:e.pageX,y:e.pageY})
      }

      document.onmouseup = function(e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
})
/**
 * @author: POPE
 * @description: 自定义指令-表格滚动
 * @param {type}
 * @return:
 */
Vue.directive('loadmore', {
  bind(el, binding) {
    let timer;
    const selectWrap = el.querySelector('.el-table__body-wrapper')
    selectWrap.addEventListener('scroll', function() {
      if (timer) {
        clearTimeout(timer);
      }
      // 原本为0，有些电脑的浏览器滚到底不会为0，不触发事件,并添加防抖
      timer = setTimeout(() => {
        if (this.scrollTop === 0) return;
        let sign = 30
        const scrollDistance =
          this.scrollHeight - this.scrollTop - this.clientHeight
        // console.log(scrollDistance)
        if (scrollDistance <= sign) {
          binding.value()
        }
      }, 100)
    })
  }
})
